import React, { Component } from "react";
import { connect } from "react-redux";
import { gethomedata } from "store/home/actions";
import PropTypes from "prop-types";
import axios from "axios";
import NeqasLogo from "../../assets/images/LogoNeqas.jpg";

class VerifyCertificate extends Component {
  state = {
    status: "loading",
    fadeIn: false,
    schemeData: null,
    apiData: null,
  };

 componentDidMount() {
  setTimeout(() => this.setState({ fadeIn: true }), 100);

  const queryParams = new URLSearchParams(this.props.location.search);
  const account_id = queryParams.get("account_id");
  const scheme_id = queryParams.get("scheme_id");
  const cycle_id = queryParams.get("cycle_id");

  // ✅ Guard — if no account_id, mark invalid immediately
  if (!account_id || account_id === "null") {
    this.setState({ status: "invalid" });
    return;
  }

  axios
    .get(`https://externalqcapi.com/api/lab/home-data/${account_id}`)
    .then((res) => {
      const data = res.data.data;
      const purchased = data.purchased_schemes;

      const match = purchased.find(
        (s) =>
          String(s.scheme_id) === String(scheme_id) &&
          String(s.cycle_id) === String(cycle_id) &&
          s.payment_reconcile_status === "Verified",
      );

      if (match) {
        this.setState({ status: "valid", schemeData: match, apiData: data });
      } else {
        this.setState({ status: "invalid" });
      }
    })
    .catch(() => this.setState({ status: "invalid" }));
}
  render() {
    const { status, fadeIn, schemeData, apiData } = this.state;

    const data = apiData || {};
    const name = data?.name || "-";
    const payments = data?.payment_details?.payments || [];
    const latestPayment = payments[0] || {};

    const city = latestPayment?.city || "-";
    const province = latestPayment?.province || "-";
    const membershipStatus = latestPayment?.membership_status || "-";

    const scheme = schemeData?.scheme_name || "-";
    const cycle = schemeData?.cycle_no || "-";

    const paymentStatus = latestPayment?.payment_status || "-";
    const paymentMethod = latestPayment?.paymentmethod || "-";
    const payDate = latestPayment?.paydate
      ? (() => {
          const d = new Date(latestPayment.paydate);
          const day = String(d.getDate()).padStart(2, "0");
          const month = d.toLocaleString("en-GB", { month: "short" });
          const year = d.getFullYear();
          return `${day}-${month}-${year}`;
        })()
      : "-";
    const price = latestPayment?.price
      ? `PKR ${Number(latestPayment.price).toLocaleString()}`
      : "-";
    const receivedBy = latestPayment?.receivedby || "-";

    return (
      <div style={styles.page}>
        <div
          style={{
            ...styles.card,
            opacity: fadeIn ? 1 : 0,
            transform: fadeIn ? "translateY(0)" : "translateY(28px)",
            transition: "all 0.65s cubic-bezier(0.22,1,0.36,1)",
          }}
        >
          {/* HEADER */}
          <div style={styles.header}>
            <img src={NeqasLogo} alt="NEQAS Logo" style={styles.logo} />
            <div>
              <h2 style={styles.title}>Certificate Verification</h2>
              <p style={styles.subtitle}>NHS – NEQAS Portal</p>
            </div>
          </div>

          <div style={styles.divider} />

          {/* STATUS */}
          {status === "loading" && (
            <div style={styles.statusBox}>
              <div style={styles.pulseRing} />
              <p style={styles.statusText}>Verifying certificate...</p>
            </div>
          )}

          {status === "valid" && (
            <div
              style={{
                ...styles.statusBadge,
                background: "#e9faf0",
                border: "1px solid #34c759",
              }}
            >
              <span>✔</span>
              <div>
                <div style={{ ...styles.statusLabel, color: "#1a7a36" }}>
                  Verified Certificate
                </div>
                <div style={styles.statusSub}>
                  Authentic record confirmed in system
                </div>
              </div>
            </div>
          )}

          {status === "invalid" && (
            <div
              style={{
                ...styles.statusBadge,
                background: "#fff0f0",
                border: "1px solid #ff3b30",
              }}
            >
              <span>✖</span>
              <div>
                <div style={{ ...styles.statusLabel, color: "#c0392b" }}>
                  Invalid Certificate
                </div>
                <div style={styles.statusSub}>
                  No record found — possible tampering
                </div>
              </div>
            </div>
          )}

          {/* DETAILS */}
          {status === "valid" && (
            <>
              <Section title="Participant Info">
                <Row label="Lab Name" value={name} />
                <Row label="City" value={city} />
                <Row label="Province" value={province} />
                <Row label="Membership" value={membershipStatus} />
              </Section>

              <Section title="Scheme Details">
                <Row label="Scheme" value={scheme} />
                <Row label="Cycle" value={cycle} />
              </Section>

              <Section title="Payment Info">
                <Row label="Amount" value={price} />
                <Row label="Method" value={paymentMethod} />
                <Row label="Date" value={payDate} />
                <Row label="Received By" value={receivedBy} />
                <Row label="Status" value={paymentStatus} />
              </Section>
            </>
          )}
        </div>
      </div>
    );
  }
}

VerifyCertificate.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  gethomedata: PropTypes.func.isRequired,
};

/* COMPONENTS */
const Section = ({ title, children }) => (
  <div style={styles.section}>
    <div style={styles.sectionTitle}>{title}</div>
    <div style={styles.sectionBody}>{children}</div>
  </div>
);

const Row = ({ label, value }) => (
  <div style={styles.row}>
    <div style={styles.rowLabel}>{label}</div>
    <div style={styles.rowValue}>{value}</div>
  </div>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

/* STYLES */
const styles = {
  page: {
    minHeight: "100vh",
    background: "#f5f7fb",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "150px 16px 60px",
    fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif",
    position: "relative",
  },
  card: {
    width: "100%",
    maxWidth: 760,
    background: "#fff",
    borderRadius: 20,
    padding: 24,
    boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  logo: {
    height: 50,
  },
  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
  },
  subtitle: {
    margin: 0,
    fontSize: 12,
    color: "#000000",
  },
  divider: {
    height: 1,
    background: "#eee",
    margin: "15px 0",
  },
  statusBox: {
    textAlign: "center",
    padding: 10,
  },
  pulseRing: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "rgba(0,122,255,0.2)",
    margin: "0 auto",
  },
  statusText: {
    fontSize: 13,
    color: "#000000",
  },
  statusBadge: {
    display: "flex",
    gap: 10,
    padding: 12,
    borderRadius: 12,
    marginBottom: 10,
  },
  statusLabel: {
    fontWeight: 700,
  },
  statusSub: {
    fontSize: 12,
    color: "#000000",
  },
  section: {
    marginTop: 15,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: "#000000",
    marginBottom: 8,
  },
  sectionBody: {
    background: "#f9f9fb",
    borderRadius: 10,
    overflow: "hidden",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 12px",
    borderBottom: "1px solid #eee",
  },
  rowLabel: {
    fontSize: 12,
    color: "#000000",
  },
  rowValue: {
    fontSize: 13,
    fontWeight: 500,
  },
};

export default connect(
  (state) => ({ home: state.home.home }),
  { gethomedata }
)(VerifyCertificate);